import pre from './pre';
import post from './post';
import config from './config/index.vue';
import cart from './cart.vue';
import success from './success.vue';
import addon from './addon.vue';

export default {
  pre,
  components: {
    addon,
    config,
    cart,
    success,
  },
  post,
};
